import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

// Custom layout
import MainLayout from "../../../../Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";
import { validateInput } from "Services/Utils/validateInput";

//slice
import { fetchIndividualFAQ } from "../../../../Redux/Slices/contentManagementSlice";

const ViewFAQ = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [faqData, setFaqData] = useState(null);

  useEffect(() => {
    dispatch(
      fetchIndividualFAQ({
        data: {
          id: id,
        },
        callBack: fetchFAQCB,
      })
    );
  }, [id]);

  const fetchFAQCB = (data) => {
    console.log(data.result);
    setFaqData(data.result);
  };

  return (
    <MainLayout pageName={"Content Management"}>
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to FAQ List</p>
      </div>
      <div className="faq-profile-details">
        <div className="view-faq-container-header">
          <h2>View FAQ Details</h2>
        </div>

        <hr style={{ backgroundColor: "#E6E6E6" }} />

        <div className="faq-details-container">
          {faqData ? (
            <>
              <div className="faq-details-item">
                <div className="objKey">Question</div>
                <div>: {faqData.question ?? "Not Captured"}</div>
              </div>
              <div className="faq-details-item">
                <div className="objKey">Answer</div>
                <div>: {faqData.answer ?? "Not Captured"}</div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewFAQ;
